import COLORS from '@lib/constants/colors';
import { customLink, linkResolver } from '@lib/data/prismic/helpers';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import React, { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  blockquote {
    padding: 24px;
    background-color: rgb(241, 244, 246);
    border-left: 4px solid ${COLORS.pink};

    font-weight: lighter;
  }

  *:last-child {
    margin-bottom: 0;
  }

  *:first-child {
    margin-top: 0;
  }

  margin: 30px 0;
`;

export const Note: FC = ({ children }) => (
  <Container>
    <blockquote>{children}</blockquote>
  </Container>
);

const SliceNote = ({
  slice,
}: {
  slice: { primary: { note: RichTextBlock[] } };
}) => (
  <Note>
    <RichText
      render={slice.primary.note}
      linkResolver={linkResolver}
      serializeHyperlink={customLink}
    />
  </Note>
);

export default SliceNote;
